/**
 *  Initialize accordion
 */

var accordion = (function() {
  var pub = {}; // public facing functions

  pub.init = function() {
    $('[data-accordion]').click(function(event) {
      event.preventDefault();
      var $btn = $(this);
      var accordionID = $btn.attr('data-accordion');
      var $accordion = $(document).find(accordionID);

      // Slide Toggle Accordion
      $accordion.slideToggle();
      $btn.toggleClass('is-expanded');
    });
  };

  return pub;
})();
